if(typeof _.has === 'undefined') { var e = new Error("Cannot find module '_.has'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.has;